import React, { useEffect, useState } from 'react';
import { photographerAPI } from '../services/api';

const Impressum = () => {
  const [impressum, setImpressum] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchImpressum();
  }, []);

  const fetchImpressum = async () => {
    try {
      const response = await photographerAPI.getInfo();
      setImpressum(response.info.impressum || 'Impressum wird noch bearbeitet.');
    } catch (error) {
      console.error('Error fetching impressum:', error);
      setImpressum('Impressum konnte nicht geladen werden.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="section-spacing-large bg-gray-50">
        <div className="photo-container text-center">
          <h1 className="hero-title mb-6">Impressum</h1>
          <p className="subtitle max-w-2xl mx-auto">
            Angaben gemäß § 5 TMG
          </p>
        </div>
      </section>

      {/* Impressum Content */}
      <section className="section-spacing">
        <div className="photo-container">
          <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-sm p-8">
            {loading ? (
              <p className="text-center text-gray-500">Wird geladen...</p>
            ) : (
              <div className="prose max-w-none">
                <pre className="whitespace-pre-wrap font-body text-gray-700 leading-relaxed">
                  {impressum}
                </pre>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Impressum;
